// import { vipEventData } from '@/service/event';
import { newEventData } from '@/service/event';
import { sessionTokenNew } from '@/utils';
// arms替代友盟
// import { init,setUserConfig } from '@umengfe/apm';

// 友盟
// init({
//   pageFilter: {
//   mode:'ignore',
//   rules:[]
//   },
//   pid:'655b416db2f6fa00ba831647',
//   logLevel: 0
//  });


window.addEventListener('load', () => {
  newEventData({
    event_id: '8888888',
    refer: location.href,
    userAgent: navigator.userAgent
  })
}, true)


window.addEventListener('error', (error) => {
  // console.log(error,'errrrr')
  newEventData({
    event_id: '0000000',
    refer: location.href,
    userAgent: navigator.userAgent,
    error_message: error
  })
}, true)


// let __bl = null;
try{
  const sessionToken = 'SESSIONTOKEN';
  let token = localStorage.getItem(sessionToken);
  if (!token) {
    const res = sessionTokenNew()//await getSessionToken();
    token = res;
    localStorage.setItem(sessionToken, token);
  }
  // let config = window.jiankongConfig || {}
  // const BrowserLogger = require('alife-logger');
  // __bl = BrowserLogger.singleton({
  //   ...config,
  //   uid: token + getQueryString('type'),
  //   environment: getEnv()
  // })
  // if(setUserConfig){
  //   setUserConfig({puid: token, tag: process.env.VUE_APP_key});
  // }  
}catch (e) {
  console.log(e)
}

// function getEnv(){
//   let linkHref = location.href || '';
//   return location.port ? 'local' : linkHref.includes('dev-') ? 'daily' : linkHref.includes('qa1-') ? 'pre' : linkHref.includes('sit-') ? 'gray' : 'prod'
// }

// function getQueryString (name, path) {
//   let target = path ? path : window.location.search;
//   let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
//   let r = target.substr(1).match(reg);
//   if (r != null) return decodeURI(r[2]);
//   return '';
// }
// export default __bl;
